module.exports = __webpack_public_path__ + "img/undraw_Messaging_fun_re_vic9.8f2899a2.svg";